import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import LoginRegister from "@/views/LoginRegister";
import Trends from "@/views/Trends";
import TrendDetail from "@/views/TrendDetail";
import OfflinePaymentHome from "@/views/OfflinePaymentHome";
import ProductDetail from "@/views/ProductDetail";
import OnlinePaymentHome from "@/views/OnlinePaymentHome";
import Cart from "@/views/Cart";
import StoreList from "@/views/StoreList";
import ProductsList from "@/views/ProductsList";
import StoreProfile from "@/views/StoreProfile";
import NewsesList from "@/views/Contents/NewsesList";
import ReviewsList from "@/views/Contents/ReviewsList";
import ArticlesList from "@/views/Contents/ArticlesList";
import ContentsDetail from "@/views/Contents/ContentsDetail";
import SearchProducts from "@/views/Search/SearchProducts";
import SearchStores from "@/views/Search/SearchStores";
import SearchTags from "@/views/Search/SearchTags";
import FAQ from "@/views/SideBarPages/FAQ";
import CriticsAndSuggestions from "@/views/SideBarPages/CriticsAndSuggestions";
import RulesOfRegulation from "@/views/SideBarPages/RulesOfRegulation";
import ConnectUs from "@/views/SideBarPages/ConnectUs";
import AboutUs from "@/views/SideBarPages/AboutUs";
import ProfileInSite from "@/views/ProfileInSite";
import BuyerProfile from "@/views/Buyer/BuyerProfile";
import BuyerProfileSetting from "@/views/Buyer/BuyerProfileSetting";
import BuyerManagePosts from "@/views/Buyer/BuyerManagePosts";
import BuyerSendComments from "@/views/Buyer/BuyerSendComments";
import BuyerReceivedComments from "@/views/Buyer/BuyerReceivedComments";
import BuyerSaveProducts from "@/views/Buyer/BuyerSaveProducts";
import BuyerFollowing from "@/views/Buyer/BuyerFollowing";
import BuyerSavePosts from "@/views/Buyer/BuyerSavePosts";
import BuyerCart from "@/views/Buyer/BuyerCart";
import SellerProfile from "@/views/Seller/SellerProfile";
import SellerProfileSetting from "@/views/Seller/SellerProfileSetting";
import SellerStoreSetting from "@/views/Seller/SellerStoreSetting";
import SellerProductManagement from "@/views/Seller/SellerProductManagement";
import SellerPostsManagement from "@/views/Seller/SellerPostsManagement";
import SellerComments from "@/views/Seller/SellerComments";
import SellerDiscountCoupon from "@/views/Seller/SellerDiscountCoupon";
import SellerShippingTariffs from "@/views/Seller/SellerShippingTariffs";
import SellerCart from "@/views/Seller/SellerCart";
import goTo from 'vuetify/lib/services/goto';
import SellerFollowing from "@/views/Seller/SellerFollowing";
import Support from "@/views/SideBarPages/Support";


Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        redirect: '/Home'
    },
    {
        path: "/Home",
        name: "home",
        component: Home,

    },
    {
        path: '/Trends',
        name: "Trends",
        component: Trends,
    },
    {
        path: "/LoginRegister",
        name: "LoginRegister",
        component: LoginRegister,
    },
    {
        path: "/TrendDetail",
        name: "TrendDetail",
        component: TrendDetail,
    },
    {
        path: "/OfflinePaymentHome",
        name: "OfflinePaymentHome",
        component: OfflinePaymentHome,
    },
    {
        path: "/ProductDetail",
        name: "ProductDetail",
        component: ProductDetail,
    },
    {
        path: "/OnlinePaymentHome",
        name: "OnlinePaymentHome",
        component: OnlinePaymentHome,
    },
    {
        path: "/Cart",
        name: "Cart",
        component: Cart,
    },
    {
        path: "/StoreList",
        name: "StoreList",
        component: StoreList,
    },
    {
        path: "/ProductsList",
        name: "ProductsList",
        component: ProductsList,
    },
    {
        path: "/StoreProfile",
        name: "StoreProfile",
        component: StoreProfile,
    },
    {
        path: "/NewsesList",
        name: "NewsesList",
        component: NewsesList,
    },
    {
        path: "/ReviewsList",
        name: "ReviewsList",
        component: ReviewsList,
    },
    {
        path: "/ArticlesList",
        name: "ArticlesList",
        component: ArticlesList,
    },
    {
        path: "/ContentsDetail",
        name: "ContentsDetail",
        component: ContentsDetail,
    },
    {
        path: "/SearchTags",
        name: "SearchTags",
        component: SearchTags,
    },
    {
        path: "/SearchStores",
        name: "SearchStores",
        component: SearchStores,
    },
    {
        path: "/SearchProducts",
        name: "SearchProducts",
        component: SearchProducts,
    },
    {
        path: "/FAQ",
        name: "FAQ",
        component: FAQ,
    },
    {
        path: "/CriticsAndSuggestions",
        name: "CriticsAndSuggestions",
        component: CriticsAndSuggestions,
    },
    {
        path: "/RulesOfRegulation",
        name: "RulesOfRegulation",
        component: RulesOfRegulation,
    },
    {
        path: "/ConnectUs",
        name: "ConnectUs",
        component: ConnectUs,
    },
    {
        path: "/AboutUs",
        name: "AboutUs",
        component: AboutUs,
    },
    {
        path: "/ProfileInSite",
        name: "ProfileInSite",
        component: ProfileInSite,
    },
    {
        path: "/BuyerProfile",
        name: "BuyerProfile",
        component: BuyerProfile,
    },
    {
        path: "/BuyerProfileSetting",
        name: "BuyerProfileSetting",
        component: BuyerProfileSetting,
    },
    {
        path: "/BuyerManagePosts",
        name: "BuyerManagePosts",
        component: BuyerManagePosts,
    },
    {
        path: "/BuyerSendComments",
        name: "BuyerSendComments",
        component: BuyerSendComments,
    },
    {
        path: "/BuyerReceivedComments",
        name: "BuyerReceivedComments",
        component: BuyerReceivedComments,
    },
    {
        path: "/BuyerSaveProducts",
        name: "BuyerSaveProducts",
        component: BuyerSaveProducts,
    },
    {
        path: "/BuyerFollowing",
        name: "BuyerFollowing",
        component: BuyerFollowing,
    },
    {
        path: "/BuyerSavePosts",
        name: "BuyerSavePosts",
        component: BuyerSavePosts,
    },
    {
        path: "/BuyerCart",
        name: "BuyerCart",
        component: BuyerCart,
    },
    {
        path: "/SellerProfile",
        name: "SellerProfile",
        component: SellerProfile,
    },
    {
        path: "/SellerProfileSetting",
        name: "SellerProfileSetting",
        component: SellerProfileSetting,
    },
    {
        path: "/SellerStoreSetting",
        name: "SellerStoreSetting",
        component: SellerStoreSetting,
    },
    {
        path: "/SellerProductManagement",
        name: "SellerProductManagement",
        component: SellerProductManagement,
    },
    {
        path: "/SellerPostsManagement",
        name: "SellerPostsManagement",
        component: SellerPostsManagement,
    },
    {
        path: "/SellerComments",
        name: "SellerComments",
        component: SellerComments,
    },
    {
        path: "/SellerDiscountCoupon",
        name: "SellerDiscountCoupon",
        component: SellerDiscountCoupon,
    },
    {
        path: "/SellerShippingTariffs",
        name: "SellerShippingTariffs",
        component: SellerShippingTariffs,
    },
    {
        path: "/SellerCart",
        name: "SellerCart",
        component: SellerCart,
    },
    {
        path: "/SellerFollowing",
        name: "SellerFollowing",
        component: SellerFollowing,
    },
    {
        path: "/Support",
        name: "Support",
        component: Support,
    },

];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    scrollBehavior: (to, from, savedPosition) => {
        let scrollTo = 0

        if (to.hash) {
            scrollTo = to.hash
        } else if (savedPosition) {
            scrollTo = savedPosition.y
        }

        return goTo(scrollTo)
    },
    routes,
});

export default router;
